class ShippingEstimate extends HTMLElement {
  connectedCallback() {
    const locale = this.dataset.locale || "en-US";
    const options = { weekday: "long", month: "long", day: "numeric" };

    this.querySelectorAll(".shipping-date").forEach((el) => {
      const daysToAdd = parseInt(el.dataset.days, 10);
      if (isNaN(daysToAdd)) return;

      const date = new Date();
      date.setDate(date.getDate() + daysToAdd);
      el.textContent = date.toLocaleDateString(locale, options);
    });
  }
}

customElements.define("shipping-estimate", ShippingEstimate);
